import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { AppBarNotification } from './appBarNotification';
import { LoggedInUser } from '../../state/helperServices/auth/auth.interfaces';
import { AccountTypes } from '../changeUser/accountTypes.enum';
import { ToggleThemeSwitch } from '../toggleThemeSwitch/toggleThemeSwitch';

interface AppBarMenuProps {
  menuItems: any;
  menuId: string;
  anchorEl: HTMLElement | undefined | null;
  setAnchorEl: (anchorEl: null | HTMLElement) => void;
  onNotificationClick: any;
  unreadNotificationCount: number | undefined;
  loggedInUser: LoggedInUser | undefined;
}

export function AppBarMobileMenu({
  menuItems,
  menuId,
  anchorEl,
  setAnchorEl,
  onNotificationClick,
  unreadNotificationCount,
  loggedInUser,
}: AppBarMenuProps) {
  const { t } = useTranslation();
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuAction = () => {
    handleMenuClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{ mt: 4 }}
    >
      <MenuItem onClick={menuAction}>
        <ToggleThemeSwitch label={t('THEME')} />
      </MenuItem>

      {loggedInUser?.accountType !== AccountTypes.Clinic && (
        <MenuItem onClick={menuAction}>
          <AppBarNotification
            onNotificationClick={onNotificationClick}
            unreadNotificationCount={unreadNotificationCount}
            label={t('notification.NOTIFICATIONS')}
          />
        </MenuItem>
      )}

      {menuItems.map((item: any) => {
        return (
          <MenuItem onClick={item.onClick} key={item.value}>
            <IconButton
              size="large"
              aria-label={t('accessibility.ACCOUNT_OF_CURRENT_USER')}
              aria-controls={menuId}
              aria-haspopup="true"
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <p>{item.text}</p>
          </MenuItem>
        );
      })}
    </Menu>
  );
}
